import { css, useTheme } from "@emotion/react";
import { omit } from "lodash/fp";
import { Fragment, useState } from "react";

import {
  useThemeProps,
  Button,
  Heading,
  TypographyBlock,
  Section,
  Card,
  parseStyle,
  CardContent,
  generateUniqueId,
  InlineList,
} from "../../wsui/base";

CardBillboardModule.wsuiConfig = {
  hasCaption: false,
};

export default function CardBillboardModule(props) {
  const theme = useTheme();
  props = useThemeProps({
    props,
    name: "MunicipioCardBillboardModule",
  });
  let {
    color,
    content,
    links,
    image,
    imagePlacement = "left",
    title,
    style,
    horizontalContentMaxWidth = "100%",
    titleVariant = "h2",
    buttonProps,
    headingId,
    align,
    ...restProps
  } = omit(["imageAspectRatio", "format"], props);
  const contentAlign =
    align === "left" || align === "center" || align === "right"
      ? align
      : undefined;
  const inlineListAlign =
    contentAlign === "left"
      ? "start"
      : contentAlign === "right"
        ? "end"
        : contentAlign === "center"
          ? "center"
          : undefined;

  const [defaltHeadingId] = useState(
    () => `module-heading-${generateUniqueId()}`,
  );
  headingId = headingId || defaltHeadingId;

  let MaybeSection = title ? Section : Fragment;

  return (
    <Card
      color={color || "transparent"}
      image={image}
      mirrored={imagePlacement === "right"}
      css={css`
        ${parseStyle(style, theme)}
      `}
      horizontalContentMaxWidth={horizontalContentMaxWidth}
      {...restProps}
    >
      <CardContent rowGap={2}>
        {!!title && (
          <Heading variant={titleVariant} id={headingId} align={contentAlign}>
            {title}
          </Heading>
        )}
        <MaybeSection>
          <TypographyBlock
            elementMapping={{ p: "description" }}
            marginAfter
            align={contentAlign}
          >
            {content}
          </TypographyBlock>
        </MaybeSection>
        {!!links?.length && (
          <InlineList align={inlineListAlign}>
            {links.map(({ link, variant = "primary" }, index) => (
              <Button
                key={index}
                {...link}
                variant={variant}
                {...buttonProps}
              />
            ))}
          </InlineList>
        )}
      </CardContent>
    </Card>
  );
}
